/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 09:36:46
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-04 10:14:08
 */

import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Upload,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import styles from './versionManagement.module.css'
import { NavBar } from '../../compnents/nav/NavBar'
import { ThemeContext } from '../../theme/ThemeContext'
import { AddVersionModal } from './addVersionModal'
import { EditMenuVersionModal } from './editMenuVersionModal'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getJurisdiction,
  getVersionManagementLit,
} from './versionManagementSlice'
import { EditThreeMenuVersionModal } from './editThreeMenuVersionModal'

// 版本管理
export const VersionManagement = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  // const tenantId =

  const [data, setData] = useState<any>()

  const [params, setParams] = useState({
    current: 1,
    size: 1000,
  })

  const [isAddVersionModel, setIsAddVersionModelVisible] = useState(false)

  const [isEditMenuVersionModal, setIsEditMenuVersionModal] = useState(false)

  const [
    isEditThreeMenuVersionModal,
    setIsEditThreeMenuVersionModal,
  ] = useState(false) //三级菜单

  

  const [name, setName] = useState<any>()

  const [labelList, setLabelList] = useState<any>()

  const [id, setId] = useState<any>()

  const [versionEdition, setVersionEdition] = useState<any>()

  const labelStyle = {
    style: {
      color: theme.tc1,
      fontSize: '14px',
      textAlign: 'left',
      marginBottom: 13,
    } as React.CSSProperties,
  }

  const titleStyle = {
    style: {
      color: theme.tc1,
      fontSize: '14px',
      textAlign: 'left',
      marginTop: 12,
    } as React.CSSProperties,
  }

  const valueStyle = {
    flex: 1,
    style: {
      color: theme.tc1,
      fontSize: '14px',
      marginBottom: 13,
      textAlign: 'left',
    } as React.CSSProperties,
  }

  const getPage = () => {
    dispatch(getVersionManagementLit({ ...params }))
      .then(unwrapResult)
      .then((v: any) => {
        setData(
          v?.records?.map((v: any) => {
            return { ...v, labelList: v?.labels ? v?.labels?.split(',') : [] }
          })
        )
      })
  }

    // const getThreePage = () => {
    //   dispatch(getVersionManagementLit({ ...params }))
    //     .then(unwrapResult)
    //     .then((v: any) => {
    //       setData(
    //         v?.records?.map((v: any) => {
    //           return { ...v, labelList: v?.labels ? v?.labels?.split(',') : [] }
    //         })
    //       )
    //     })
    // }


  useEffect(() => {
    getPage()
    // getThreePage()
  }, [params])

  console.log(data, 'datattt')

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        margin: '10px 20px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <NavBar
        where={['版本管理', '']}
        buttons={
          <Button
            type='primary'
            onClick={() => setIsAddVersionModelVisible(true)}
          >
            新增版本
          </Button>
        }
        type={false}
      />
      <Col
        style={{
          flex: 1,
          overflow: 'scroll',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '10px 15px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        {data?.map((v: any) => {
          return (
            <>
              <Row className={styles.titleContent}>
                <div className={styles.title}>
                  <Col span={14} className={styles.titleLeft}>
                    {v?.name}
                  </Col>
                  <Col span={10} className={styles.titleRight}>
                    <Button
                      type='primary'
                      ghost
                      size='small'
                      onClick={() => {
                        Modal.confirm({
                          centered: true,
                          title: '',
                          content: <div>是否确认分配权限？</div>,
                          okText: '确认',
                          cancelText: '取消',
                          icon: null,
                          onOk: () => {
                            dispatch(getJurisdiction(v?.id))
                              .then(unwrapResult)
                              .then((v: any) => {
                                console.log(v, '是否确认分配权限？')

                                notification.success({
                                  message: v?.msg,
                                  duration: 3,
                                })
                                getPage()
                              })
                          },
                        })
                      }}
                    >
                      分配权限
                    </Button>
                    {/* <a
                      onClick={() => {
                        setIsEditThreeMenuVersionModal(true)
                        setId(v?.id)
                        setVersionEdition(v?.versionEdition)
                      }}
                    >
                      二三四级菜单编辑权限
                    </a> */}
                    <a
                      style={{ marginLeft: '20px' }}
                      onClick={() => {
                        setIsEditMenuVersionModal(true)
                        setId(v?.id)
                        setVersionEdition(v?.versionEdition)
                      }}
                    >
                      菜单编辑权限
                    </a>
                    <a
                      style={{ marginLeft: '20px' }}
                      onClick={() => {
                        setIsAddVersionModelVisible(true)
                        setName(v?.name)
                        setLabelList(v?.name)
                        setId(v?.id)
                      }}
                    >
                      设置
                    </a>
                  </Col>
                </div>
                <div className={styles.content}>
                  <Row
                    style={{ marginLeft: '40px' }}
                    className={styles.labelContent}
                  >
                    <Col {...titleStyle}>标签：</Col>
                    <Col span={23}>
                      <Row className={styles.labels}>
                        {v?.labelList?.map((i: any) => {
                          return (
                            <>
                              <div className={styles.label}>{i} </div>
                            </>
                          )
                        })}
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={20} style={{ marginLeft: '30px' }}>
                    {v?.versionPropertiesVOList?.map((b: any) => {
                      return (
                        <>
                          <Col span={8}>
                            <Row>
                              <Col {...labelStyle}>{b?.name}：</Col>
                              {b?.name == '宣传图'
                                ? b?.propValue && (
                                    <a href={b?.propValue}>查看</a>
                                  )
                                : b?.propValue == 'true'
                                ? '是'
                                : b?.propValue == 'false'
                                ? '否'
                                : b?.propValue}
                              <Col {...valueStyle}></Col>
                            </Row>
                          </Col>
                        </>
                      )
                    })}
                  </Row>
                </div>
              </Row>
            </>
          )
        })}
      </Col>
      <AddVersionModal
        id={id}
        visible={isAddVersionModel}
        onCancel={() => {
          setIsAddVersionModelVisible(false)
          getPage()
          setId('')
        }}
        onOk={() => {
          setIsAddVersionModelVisible(false)
          getPage()
          setId('')
        }}
      />
      <EditMenuVersionModal
        versionEdition={versionEdition}
        id={id}
        visible={isEditMenuVersionModal}
        onCancel={() => {
          setIsEditMenuVersionModal(false)
          getPage()
          setId('')
        }}
        onOk={() => {
          setIsEditMenuVersionModal(false)
          getPage()
          setId('')
        }}
      />
      <EditThreeMenuVersionModal
        versionEdition={versionEdition}
        id={id}
        visible={isEditThreeMenuVersionModal}
        onCancel={() => {
          setIsEditThreeMenuVersionModal(false)
          // getThreePage()
          setId('')
        }}
        onOk={() => {
          setIsEditThreeMenuVersionModal(false)
          // getThreePage()
          setId('')
        }}
      />
    </Col>
  )
}
